import { FileModel, FileResponse } from './../../models/files/fileModel';
import { adminHttpClient } from "../../commons/adminHttpClinet";

 const uploadIcon = (model: FormData ): Promise<FileResponse> => {
  return adminHttpClient.post("/api/Admin/AdminFiles/image", model);
};
export  default uploadIcon;